// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Big-screen content for the Drawn Together move. */

.drawerStatusList {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-auto-rows: 1fr;
  gap: 1rem;
  list-style: none;
  padding: 0;
  margin: 0.35rem 0 0.5rem;
  width: 100%;
}

.drawerStatusList > li:last-child:nth-child(odd) {
  grid-column: 1 / -1;
}

@media (max-width: 600px) {
  .drawerStatusList {
    grid-template-columns: 1fr;
  }
}

.drawerStatusList li {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.85rem 1rem;
  border-radius: var(--border-radius);
  background: var(--sky-soft);
  border: 2px solid transparent;
  box-sizing: border-box;
  min-height: 4.25rem;
  text-align: left;
  color: var(--ink-soft);
}

.drawerStatusList li .drawerName {
  flex: 1;
  min-width: 0;
  font-family: var(--font-heading);
  font-weight: 600;
  font-size: 1.2rem;
  color: var(--ink);
  overflow-wrap: anywhere;
}

.drawerStatusList li .drawerStatus {
  flex-shrink: 0;
  font-size: 0.95rem;
  font-weight: 700;
}

.drawerStatusList li.done {
  background: #eef8fe;
  border-color: var(--navy);
  color: var(--ink);
}

.drawerCheck {
  flex-shrink: 0;
  width: 1.9rem;
  height: 1.9rem;
  border-radius: 50%;
  background: var(--navy);
  position: relative;
}

.drawerCheck::after {
  content: "";
  position: absolute;
  left: 0.62rem;
  top: 0.32rem;
  width: 0.45rem;
  height: 0.85rem;
  border-right: 3px solid var(--white);
  border-bottom: 3px solid var(--white);
  transform: rotate(45deg);
}

/* Showcase: the sketch with the poster fading in over it. */

.posterShowcase .showcaseCounter {
  font-size: 0.95rem;
  color: var(--ink-soft);
  margin: 0;
}

.posterShowcase .showcaseQuestion {
  font-size: 1.2rem;
  color: var(--ink-soft);
  margin: 0.2rem 0;
}

.posterShowcase .showcaseAnswer {
  font-family: var(--font-heading);
  font-weight: 600;
  font-size: 1.9rem;
  line-height: 2.4rem;
  margin: 0.5rem 0 1rem;
}

.showcaseViewport {
  position: relative;
  overflow: hidden;
  width: 100%;
}

.showcaseBody.enter {
  animation: showcaseSlideIn 0.55s cubic-bezier(0.22, 1, 0.36, 1) both;
}

.showcaseBody.exit {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  animation: showcaseSlideOut 0.55s cubic-bezier(0.22, 1, 0.36, 1) both;
  pointer-events: none;
}

@keyframes showcaseSlideIn {
  from { transform: translateX(100%); }
  to { transform: translateX(0); }
}

@keyframes showcaseSlideOut {
  from { transform: translateX(0); }
  to { transform: translateX(-100%); }
}

.showcaseFrame {
  position: relative;
  margin: 0 auto;
  aspect-ratio: 2 / 3;
  height: min(58vh, 36rem);
  border-radius: 12px;
  overflow: hidden;
  background-color: white;
  border: 3px solid var(--white);
  box-shadow: 0 6px 18px rgba(14, 36, 99, 0.25);
  clip-path: inset(0 0 0 0);
}

/* Reserve the frame's height during the story beat, then wipe the sketch
   in from top to bottom. */
.showcaseFrame.hidden {
  clip-path: inset(0 0 100% 0);
}

.showcaseFrame.reveal {
  animation: sketchReveal 0.9s ease-in-out both;
}

.showcaseFrame.shown {
  clip-path: inset(0 0 0 0);
}

@keyframes sketchReveal {
  from { clip-path: inset(0 0 100% 0); }
  to { clip-path: inset(0 0 0 0); }
}

.showcaseFrame img {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
  background-color: white;
}

.showcaseFrame .showcasePoster {
  object-fit: cover;
  opacity: 0;
  /* Slow cross-fade so the resemblance to the sketch is visible. */
  transition: opacity 4s ease-in-out;
}

.showcaseFrame .showcasePoster.visible {
  opacity: 1;
}

/* Voting gallery on the big screen. */

.posterGallery {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 1.2rem;
  margin-bottom: 1rem;
}

.galleryPoster {
  margin: 0;
  /* Share the row: shrink to fit everyone, only wrap when posters would
     get too small to read. */
  flex: 1 1 0;
  min-width: 8rem;
  max-width: 16rem;
}

.galleryPoster img {
  display: block;
  width: 100%;
  aspect-ratio: 2 / 3;
  object-fit: cover;
  border-radius: 12px;
  border: 3px solid var(--white);
  box-shadow: 0 6px 18px rgba(14, 36, 99, 0.25);
}

/* Poster shown inside the end-of-move marquee. */

.marqueeContainer .marqueePoster {
  display: block;
  height: 50vh;
  aspect-ratio: 2 / 3;
  object-fit: cover;
  margin: 0 auto 0.5rem;
  border-radius: 12px;
  border: 3px solid var(--sky);
}

.marqueeContainer .marqueeCaption,
.marqueeContainer .marqueeCaption p {
  font-size: 2rem;
  line-height: 2.6rem;
}
`, "",{"version":3,"sources":["webpack://./src/browser/webapp/components/room/drawn-together/drawn-together.css"],"names":[],"mappings":"AAAA,oDAAoD;;AAEpD;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,UAAU;EACV,wBAAwB;EACxB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,mCAAmC;EACnC,2BAA2B;EAC3B,6BAA6B;EAC7B,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,gCAAgC;EAChC,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,cAAc;EACd,eAAe;EACf,oCAAoC;EACpC,qCAAqC;EACrC,wBAAwB;AAC1B;;AAEA,4DAA4D;;AAE5D;EACE,kBAAkB;EAClB,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,oEAAoE;AACtE;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,WAAW;EACX,qEAAqE;EACrE,oBAAoB;AACtB;;AAEA;EACE,OAAO,2BAA2B,EAAE;EACpC,KAAK,wBAAwB,EAAE;AACjC;;AAEA;EACE,OAAO,wBAAwB,EAAE;EACjC,KAAK,4BAA4B,EAAE;AACrC;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,8BAA8B;EAC9B,6CAA6C;EAC7C,yBAAyB;AAC3B;;AAEA;2BAC2B;AAC3B;EACE,4BAA4B;AAC9B;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,OAAO,4BAA4B,EAAE;EACrC,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,UAAU;EACV,iEAAiE;EACjE,kCAAkC;AACpC;;AAEA;EACE,UAAU;AACZ;;AAEA,sCAAsC;;AAEtC;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT;6BAC2B;EAC3B,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,8BAA8B;EAC9B,6CAA6C;AAC/C;;AAEA,iDAAiD;;AAEjD;EACE,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;EACrB,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;;EAEE,eAAe;EACf,mBAAmB;AACrB","sourcesContent":["/* Big-screen content for the Drawn Together move. */\n\n.drawerStatusList {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  grid-auto-rows: 1fr;\n  gap: 1rem;\n  list-style: none;\n  padding: 0;\n  margin: 0.35rem 0 0.5rem;\n  width: 100%;\n}\n\n.drawerStatusList > li:last-child:nth-child(odd) {\n  grid-column: 1 / -1;\n}\n\n@media (max-width: 600px) {\n  .drawerStatusList {\n    grid-template-columns: 1fr;\n  }\n}\n\n.drawerStatusList li {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 0.85rem 1rem;\n  border-radius: var(--border-radius);\n  background: var(--sky-soft);\n  border: 2px solid transparent;\n  box-sizing: border-box;\n  min-height: 4.25rem;\n  text-align: left;\n  color: var(--ink-soft);\n}\n\n.drawerStatusList li .drawerName {\n  flex: 1;\n  min-width: 0;\n  font-family: var(--font-heading);\n  font-weight: 600;\n  font-size: 1.2rem;\n  color: var(--ink);\n  overflow-wrap: anywhere;\n}\n\n.drawerStatusList li .drawerStatus {\n  flex-shrink: 0;\n  font-size: 0.95rem;\n  font-weight: 700;\n}\n\n.drawerStatusList li.done {\n  background: #eef8fe;\n  border-color: var(--navy);\n  color: var(--ink);\n}\n\n.drawerCheck {\n  flex-shrink: 0;\n  width: 1.9rem;\n  height: 1.9rem;\n  border-radius: 50%;\n  background: var(--navy);\n  position: relative;\n}\n\n.drawerCheck::after {\n  content: \"\";\n  position: absolute;\n  left: 0.62rem;\n  top: 0.32rem;\n  width: 0.45rem;\n  height: 0.85rem;\n  border-right: 3px solid var(--white);\n  border-bottom: 3px solid var(--white);\n  transform: rotate(45deg);\n}\n\n/* Showcase: the sketch with the poster fading in over it. */\n\n.posterShowcase .showcaseCounter {\n  font-size: 0.95rem;\n  color: var(--ink-soft);\n  margin: 0;\n}\n\n.posterShowcase .showcaseQuestion {\n  font-size: 1.2rem;\n  color: var(--ink-soft);\n  margin: 0.2rem 0;\n}\n\n.posterShowcase .showcaseAnswer {\n  font-family: var(--font-heading);\n  font-weight: 600;\n  font-size: 1.9rem;\n  line-height: 2.4rem;\n  margin: 0.5rem 0 1rem;\n}\n\n.showcaseViewport {\n  position: relative;\n  overflow: hidden;\n  width: 100%;\n}\n\n.showcaseBody.enter {\n  animation: showcaseSlideIn 0.55s cubic-bezier(0.22, 1, 0.36, 1) both;\n}\n\n.showcaseBody.exit {\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  animation: showcaseSlideOut 0.55s cubic-bezier(0.22, 1, 0.36, 1) both;\n  pointer-events: none;\n}\n\n@keyframes showcaseSlideIn {\n  from { transform: translateX(100%); }\n  to { transform: translateX(0); }\n}\n\n@keyframes showcaseSlideOut {\n  from { transform: translateX(0); }\n  to { transform: translateX(-100%); }\n}\n\n.showcaseFrame {\n  position: relative;\n  margin: 0 auto;\n  aspect-ratio: 2 / 3;\n  height: min(58vh, 36rem);\n  border-radius: 12px;\n  overflow: hidden;\n  background-color: white;\n  border: 3px solid var(--white);\n  box-shadow: 0 6px 18px rgba(14, 36, 99, 0.25);\n  clip-path: inset(0 0 0 0);\n}\n\n/* Reserve the frame's height during the story beat, then wipe the sketch\n   in from top to bottom. */\n.showcaseFrame.hidden {\n  clip-path: inset(0 0 100% 0);\n}\n\n.showcaseFrame.reveal {\n  animation: sketchReveal 0.9s ease-in-out both;\n}\n\n.showcaseFrame.shown {\n  clip-path: inset(0 0 0 0);\n}\n\n@keyframes sketchReveal {\n  from { clip-path: inset(0 0 100% 0); }\n  to { clip-path: inset(0 0 0 0); }\n}\n\n.showcaseFrame img {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  background-color: white;\n}\n\n.showcaseFrame .showcasePoster {\n  object-fit: cover;\n  opacity: 0;\n  /* Slow cross-fade so the resemblance to the sketch is visible. */\n  transition: opacity 4s ease-in-out;\n}\n\n.showcaseFrame .showcasePoster.visible {\n  opacity: 1;\n}\n\n/* Voting gallery on the big screen. */\n\n.posterGallery {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 1.2rem;\n  margin-bottom: 1rem;\n}\n\n.galleryPoster {\n  margin: 0;\n  /* Share the row: shrink to fit everyone, only wrap when posters would\n     get too small to read. */\n  flex: 1 1 0;\n  min-width: 8rem;\n  max-width: 16rem;\n}\n\n.galleryPoster img {\n  display: block;\n  width: 100%;\n  aspect-ratio: 2 / 3;\n  object-fit: cover;\n  border-radius: 12px;\n  border: 3px solid var(--white);\n  box-shadow: 0 6px 18px rgba(14, 36, 99, 0.25);\n}\n\n/* Poster shown inside the end-of-move marquee. */\n\n.marqueeContainer .marqueePoster {\n  display: block;\n  height: 50vh;\n  aspect-ratio: 2 / 3;\n  object-fit: cover;\n  margin: 0 auto 0.5rem;\n  border-radius: 12px;\n  border: 3px solid var(--sky);\n}\n\n.marqueeContainer .marqueeCaption,\n.marqueeContainer .marqueeCaption p {\n  font-size: 2rem;\n  line-height: 2.6rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
